import { AUTH_URL } from 'src/constants/global'
import { useFetchCb } from '@gluedigital/ruse-fetch-extras'

export default function useAuth() {
  const doFetch = useFetchCb()

  const requestEmail = async (email: string, from?: string) => {
    return await doFetch(AUTH_URL + '/auth/magic-link', {
      method: 'POST',
      body: { email, from }
    })
  }

  return { requestEmail }
}
